// extracted by mini-css-extract-plugin
export default {"customBackDrop":"styles_customBackDrop__4u-vp","no-scrollbar":"styles_no-scrollbar__EeiCc"};